import TableFilterSelect from '@aibees/elephant/components/table-filter-select/table-filter-select';
import { ExportSearchGrouping } from '@aibees/elephant/hooks';
import { useAddExportsGroupingMetadata } from '@aibees/elephant/hooks/export/use-add-exports-grouping-metadata';
import { Stack } from '@mui/material';
import { memo } from 'react';
import { LIST_TYPE_OPTION } from './config';
import type { SearchTypesFilterProps as Props } from './types';

export const ExportsGroupingFilter = memo(
  ({ filters, setFilter, ..._props }: Props) => {
    const options = useAddExportsGroupingMetadata(LIST_TYPE_OPTION);

    return (
      <Stack flex={0.5}>
        <TableFilterSelect<ExportSearchGrouping>
          filters={filters}
          setFilter={setFilter}
          name="grouping"
          defaultValue={ExportSearchGrouping.ALL}
          options={options}
        />
      </Stack>
    );
  }
);

ExportsGroupingFilter.displayName = 'ExportsGroupingFilter';
